webpackJsonp([189066279150898],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(345);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
		return _react2.default.createElement(
			'main',
			{ className: 'contact' },
			_react2.default.createElement(
				'div',
				{ className: 'wrapper' },
				_react2.default.createElement(
					'h1',
					null,
					'Contact'
				),
				_react2.default.createElement(
					'div',
					{ className: 'contact-block' },
					_react2.default.createElement(
						'h2',
						null,
						'NEW YORK'
					),
					_react2.default.createElement(
						'p',
						null,
						'420 Lexington Avenue, Suite 300',
						_react2.default.createElement('br', null),
						'New York, NY, 10170',
						_react2.default.createElement('br', null),
						'Telephone: +1-212-297-6289',
						_react2.default.createElement('br', null),
						'peh@merchantspartners.com'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'contact-block' },
					_react2.default.createElement(
						'h2',
						null,
						'SHANGHAI'
					),
					_react2.default.createElement(
						'p',
						null,
						'Jinhuan Business Park',
						_react2.default.createElement('br', null),
						'Bldg. 3, Suite 601',
						_react2.default.createElement('br', null),
						'1977 Jinshajiang Road',
						_react2.default.createElement('br', null),
						'Shanghai, 200030, China',
						_react2.default.createElement('br', null),
						'ceh@merchantspartners.com'
					)
				)
			)
		);
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-index-js-e887cfd821dc3544af02.js